/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { WeatherStationRequest } from '../../models/weather-station-request';

export interface CreateStations$Params {
   body: WeatherStationRequest;
}

export function createStations(
   http: HttpClient,
   rootUrl: string,
   params: CreateStations$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<{}>> {
   const rb = new RequestBuilder(rootUrl, createStations.PATH, 'post');
   if (params) {
      rb.body(params.body, 'application/json');
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<{}>;
      })
   );
}

createStations.PATH = '/api/weather/weather_station';
